import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';

import formControl from './formControl';
import * as styles from './styles.css';

function Input({
  disabled,
  isEditable,
  input: {
    value,
    onChange,
    onBlur,
    name,
    ...otherInputProps
  },
  placeholder,
  type,
  maxLength,
  autoFocus,
  testID,
  formatValue,
  defaultValue,
  autocomplete,
}) {
  if (isEditable === false) {
    return <div className={styles.value}>{formatValue(value) || '-'}</div>;
  }

  return (
    <input
      {...otherInputProps}
      maxLength={maxLength}
      className="form-control "
      value={typeof value === 'undefined' ? defaultValue : value}
      disabled={disabled}
      type={type}
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
      onBlur={event => onBlur(event.target.value)}
      autoFocus={autoFocus} // eslint-disable-line
      data-testid={testID}
      name={name}
      id={name}
      autoComplete={autocomplete}
    />
  );
}

Input.defaultProps = {
  type: 'text',
  placeholder: '',
  disabled: false,
  isEditable: true,
  maxLength: undefined,
  autoFocus: false,
  testID: undefined,
  formatValue: value => value,
  defaultValue: '',
  autocomplete: undefined,
};

Input.propTypes = {
  /* input: PropTypes.shape(fieldInputPropTypes).isRequired, */
  /* meta: PropTypes.shape(fieldMetaPropTypes).isRequired, */
  disabled: PropTypes.bool,
  isEditable: PropTypes.bool,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  autoFocus: PropTypes.bool,
  testID: PropTypes.string,
  formatValue: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  autocomplete: PropTypes.string,
};

export default compose(
  formControl,
  withProps(({ min, max, input }) => ({
    input: {
      ...input,
      min: input.min || min,
      max: input.max || max,
    },
  })),
)(Input);
